// extracted by mini-css-extract-plugin
module.exports = {"CcxLogo":"CcxLogo_QP-1z"};